const baseModule = 'SOCKET';

export const START_CHANNEL_LISTENING = `${baseModule}_START_CHANNEL_LISTENING`;
export const LEAVE_CHANNEL = `${baseModule}_CHANNEL_LEAVE`;
